/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvZWotdHMvdGVuYW50LXBvcnRhbC9zdHVkZW50LXJlZ2lzdHJhdGlvbi1mb3Jtcy9zdHVkZW50LXJlZ2lzdHJhdGlvbi1mb3Jtcy5jb21wb25lbnQuY3NzIn0= */"];
export { styles as styles };
